<template>
  <form
    autocomplete="off"
    class="admin-vendors-form"
    @reset.prevent="handleCancel"
    @submit.prevent="handleSave"
  >
    <fieldset>
      <label>
        <span class="required">Name</span>

        <input
          autofocus
          :disabled="disabled"
          id="admin-vendor-name"
          required
          type="text"
          v-model.trim="name"
        />
      </label>

      <label>
        <span>Manufacturer</span>

        <select :disabled="disabled" id="admin-vendor-manufacturer" v-model.number="manufacturerId">
          <option></option>

          <option
            v-for="manufacturer in filterOptions(manufacturers, vendor.manufacturer)"
            :key="manufacturer.id"
            :value="manufacturer.id"
          >{{ manufacturer.name }}</option>
        </select>
      </label>
    </fieldset>

    <footer>
      <button
        :disabled="!isDeleteEnabled"
        id="admin-vendor-delete"
        type="button"
        @click="handleDelete"
        v-if="canDelete && vendor.id"
      >Delete</button>

      <button :disabled="!isSaveEnabled" id="admin-vendor-save" type="submit" v-if="canSave">Save</button>

      <button
        :disabled="!isCancelEnabled"
        id="admin-vendor-cancel"
        type="reset"
        v-if="canCancel"
      >Cancel</button>
    </footer>
  </form>
</template>

<script>
import { deleteVendor, saveVendor } from "../../api/VendorAPI";

export default {
  data() {
    return {
      name: undefined,
      manufacturerId: undefined
    };
  },

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    manufacturers: {
      item: Array
    },
    vendor: {
      type: Object
    }
  },

  computed: {
    canCancel() {
      return true;
    },
    canDelete() {
      return this.can("DELETE_VENDORS");
    },
    canSave() {
      return this.can({ permissions: ["CREATE_VENDORS", "UPDATE_VENDORS"], matchAny: true });
    },
    isCancelEnabled() {
      return !this.disabled;
    },
    isDeleteEnabled() {
      return !this.disabled && this.vendor?.id;
    },
    isSaveEnabled() {
      return (
        !this.disabled &&
        (this.vendor?.id
          ? this.can("UPDATE_VENDORS")
          : this.can("CREATE_VENDORS"))
      );
    }
  },

  methods: {
    handleCancel() {
      this.$emit("cancel");
    },
    async handleDelete() {
      if (!confirm("Are you sure you want to delete this vendor?")) {
        return;
      }

      await deleteVendor(this.vendor);
      this.$emit("delete", this.vendor);
    },
    async handleSave() {
      try {
        this.$emit(
          "save",
          await saveVendor({
            ...this.vendor,
            name: this.name,
            manufacturer: this.manufacturerId
              ? { id: this.manufacturerId }
              : null
          })
        );
      } catch (e) {
        this.showErrors(e, "A vendor");
      }
    },
    isDirty() {
      if (this.disabled) {
        return false;
      }

      return (
        this.name !== this.vendor?.name ||
        this.manufacturerId !== this.vendor?.manufacturer?.id
      );
    }
  },

  watch: {
    disabled(to, from) {
      !to && from && this.autofocus();
    },
    vendor: {
      immediate: true,
      handler(to, from) {
        if (to !== from) {
          this.name = to?.name;
          this.manufacturerId = to?.manufacturer?.id;
        }

        !this.disabled && this.autofocus();
      }
    }
  }
};
</script>

<style>
.admin-vendors-form {
  display: grid;
  grid-column-gap: 1em;
  grid-row-gap: 0.5em;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.admin-vendors-form > footer {
  grid-column: span 2;
  margin: 0;
  padding: 0.5em 0 0 0;
}
</style>